// FindingsPanel fixtures — for the `?debugFindings=1` shortcut on
// DocumentDetail. Mockable rendering so the UX can be iterated
// before the real proxy endpoint is wired into the Tool Palette
// invoke flow.
//
// To exercise: open any document detail page with `?debugFindings=1`
// appended to the URL. The panel opens with the mock dataset below.

import type { FindingsPanelData } from '../components/FindingsPanel.js';

export const MOCK_FINDINGS_DATA: FindingsPanelData = {
  actionKey: 'report-gen:grade-website',
  actionLabel: 'Grade — Website grading rubric',
  result: {
    schemaVersion: 'tool-invoke-result/v1',
    runId: '01J9XYZ_MOCK_FIXTURE_RUN_ID',
    findings: [
      // Errors
      {
        rule: 'wg/missing-cta',
        severity: 'error',
        source: 'report-gen',
        msg: 'No call-to-action found above the fold. Add a primary CTA button to the hero section.',
        fix: { description: 'Add a button with action verb (e.g. "Get started", "Talk to sales") inside the first 600px of the page.' },
        file: 'index.html',
        line: 42,
      },
      {
        rule: 'lighthouse/largest-contentful-paint',
        severity: 'error',
        source: 'lighthouse',
        msg: 'LCP is 4.2s — over the 2.5s target.',
        file: 'index.html',
      },
      // Warnings
      {
        rule: 'wg/no-meta-description',
        severity: 'warn',
        source: 'report-gen',
        msg: 'Missing <meta name="description"> — search engines will synthesize one, but it won\'t match your brand voice.',
        file: 'index.html',
        line: 8,
        fix: { description: 'Add a 150-160 character meta description summarizing the page\'s value proposition.' },
      },
      {
        rule: 'markdownlint/MD013',
        severity: 'warn',
        source: 'markdownlint',
        msg: 'Line length exceeds 80 characters.',
        file: 'docs/feature.md',
        line: 142,
        column: 1,
      },
      {
        rule: 'wg/heading-hierarchy',
        severity: 'warn',
        source: 'report-gen',
        msg: 'Page jumps from <h1> directly to <h3>. Add an <h2> for screen-reader friendliness.',
        file: 'index.html',
        line: 56,
      },
      // Info
      {
        rule: 'wg/social-cards',
        severity: 'info',
        source: 'report-gen',
        msg: 'No Open Graph image. Sharing this URL to social platforms will use a generic preview.',
        fix: { description: 'Add <meta property="og:image" content="..."> pointing to a 1200x630px branded card.' },
      },
      {
        rule: 'sidecar/missing-summary',
        severity: 'info',
        source: 'sidecar',
        msg: 'Document sidecar has no AI-generated summary. Re-run the sidecar enrichment to populate.',
      },
    ],
    meta: {
      grade: 'C',
      score: 68,
      rubricVersion: '2026-01',
    },
  },
};
